angular.module('aq.filters.formatters')
.filter("intaqnumber", ['$filter', function($filter) {
   return function(input) {
       if (!input) {
           return 0;
       }
       return (parseFloat as any)($filter('aqnumber')(input), 10);
   }
}]);
